module.exports = __webpack_public_path__ + "static/media/helmet-battle.ef497e80.svg";